import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

const HomeIcon = (props: SVGProps<any>): ReactElement => {
  return (
    <BaseIcon {...props} viewBox="0 0 20 20">
      <path
        d="M4.892 17.268q-.579 0-.99-.412a1.35 1.35 0 0 1-.412-.99V8.11L1.107 9.909a.65.65 0 0 1-.502.152.68.68 0 0 1-.455-.269.63.63 0 0 1-.14-.514.74.74 0 0 1 .28-.467l8.877-6.775q.186-.14.402-.222a1.23 1.23 0 0 1 .878 0q.214.083.402.222l3.317 2.523V3.485q0-.487.341-.828a1.13 1.13 0 0 1 .83-.34q.487 0 .826.34t.339.828v2.85l3.224 2.476q.233.186.268.467a.66.66 0 0 1-.151.514.68.68 0 0 1-.455.269.65.65 0 0 1-.503-.152l-2.383-1.822v7.779q0 .578-.412.99a1.35 1.35 0 0 1-.99.411h-1.588q-.579 0-.99-.411a1.35 1.35 0 0 1-.412-.99v-2.803a1.35 1.35 0 0 0-.411-.99 1.35 1.35 0 0 0-.99-.412H9.307a1.35 1.35 0 0 0-.99.412 1.35 1.35 0 0 0-.412.99v2.803q0 .578-.411.99a1.35 1.35 0 0 1-.99.411zm3.13-9.578h3.971q0-.771-.595-1.274a2.1 2.1 0 0 0-1.39-.502 2.1 2.1 0 0 0-1.39.499 1.59 1.59 0 0 0-.596 1.277" 
        fill="currentColor"
      />
    </BaseIcon>
  );
};
export default HomeIcon;
